import React, { Component } from "react";
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { Container } from "semantic-ui-react";

import { getSlots } from './actions/slotActions';
import { getTypes } from './actions/typeActions';
import AppearanceIndexComponent from './index/AppearanceIndexComponent';
import AppearanceDetailContainer from './detail/AppearanceDetailContainer';

class AppearanceContainer extends Component {

    componentDidMount() {
        this.props.getSlots();
        this.props.getTypes();
    }

    render() {
        return (
            <Container>
                <Switch>
                    <Route
                        path="/appearances"
                        component={AppearanceIndexComponent}
                        exact
                    />
                    <Route
                        path="/appearances/:id"
                        component={AppearanceDetailContainer}
                        exact
                    />
                </Switch>
            </Container>
        )
    }
}


const mapStateToProps = state => ({});

const mapDispatchToProps = () => ({
    getSlots,
    getTypes,
});

export default connect(mapStateToProps, mapDispatchToProps())(AppearanceContainer);


// WEBPACK FOOTER //
// ./src/appearances/AppearanceContainer.jsx